<div class="big-card d-block justify-content-between" [ngClass]="{ shadow: !noBox(), 'p-0': noBox(), 'd-md-flex': oneRow() }">
  <div class="d-flex flex-column justify-content-center">
    <h6 class="card-h">{{ postCodeAndStreet() }}</h6>
    <p class="mb-0">{{ description() }}</p>
  </div>
  <div class="d-flex ml-3" data-test="card-with-product-list-categories">
    @for (category of categories(); track category) {
      <div class="icon-text mr-2 mt-3 text-center">
        <mwe-product-icon [category]="category" size="lg" />
      </div>
    }
  </div>
</div>
